export default __webpack_public_path__ + "static/media/SI.d0532c8d.mp3";